<template>
  <section v-if="application && application.id" class="wa-order-panel">
    <header class="wa-order-panel__header">
      <div>
        <h3>WhatsApp</h3>
        <span>{{ application.conversation.profile_name || application.conversation.wa_id }}</span>
        <small>+{{ application.conversation.wa_id.replace(/^\+/, '') }}</small>
      </div>
      <router-link :to="dialogLink">Dialog öffnen</router-link>
    </header>

    <div v-if="documentGroups.length" class="wa-order-panel__documents">
      <h4>Dokumente</h4>
      <div v-for="group in documentGroups" :key="group.key">
        <strong>{{ documentTitle(group.key) }}</strong>
        <button
          v-for="file in group.files"
          :key="file.message_id"
          type="button"
          @click="downloadMedia(file.message_id)"
        >
          📎 {{ file.filename || file.mime_type || 'Datei' }}
        </button>
      </div>
    </div>

    <details class="wa-order-panel__messages">
      <summary>Bestellbezogene Nachrichten ({{ application.messages.length }})</summary>
      <div
        v-for="message in application.messages"
        :key="message.id"
        :class="['wa-order-panel__message', `wa-order-panel__message--${message.direction}`]"
      >
        <div>
          <p v-if="message.text">{{ message.text }}</p>
          <button
            v-if="message.media_id"
            type="button"
            @click="downloadMedia(message.id)"
          >
            📎 {{ message.filename || message.mime_type || 'Dokument' }}
          </button>
          <small>{{ formatDate(message.created_at) }}</small>
        </div>
      </div>
    </details>
    <p v-if="error" class="wa-order-panel__error">{{ error }}</p>
  </section>
</template>

<script>
export default {
  name: 'whatsapp-order-panel',
  props: {
    orderType: { type: String, required: true },
    orderId: { type: [Number, String], required: true }
  },
  data: () => ({ application: null, error: '' }),
  computed: {
    dialogLink () {
      return `/kzevb/whatsapp/?conversation_id=${this.application.conversation_id}`
    },
    documentGroups () {
      const documents = (this.application.draft_data || {}).documents || {}
      return Object.keys(documents)
        .map(key => ({ key, files: documents[key] || [] }))
        .filter(group => group.files.length)
    }
  },
  async mounted () {
    try {
      this.application = await this.$services.whatsapp.getApplicationByOrder(
        this.orderType, Number(this.orderId)
      )
    } catch (error) {
      this.error = error && error.message ? error.message : 'WhatsApp-Daten konnten nicht geladen werden.'
    }
  },
  methods: {
    async downloadMedia (messageId) {
      try {
        const media = await this.$services.whatsapp.getMedia(messageId)
        const bytes = Uint8Array.from(window.atob(media.content), char => char.charCodeAt(0))
        const url = window.URL.createObjectURL(new Blob([bytes], { type: media.mime_type }))
        const link = document.createElement('a')
        link.href = url
        link.download = media.filename
        link.click()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        this.error = error && error.message ? error.message : 'Dokument konnte nicht geladen werden.'
      }
    },
    documentTitle (key) {
      return ({
        ausweis: 'Ausweis / Reisepass',
        vehicle_documents: 'Fahrzeugdokumente',
        tuv: 'HU / TÜV',
        vollmacht: 'Vollmacht'
      })[key] || key
    },
    formatDate (value) {
      return value ? new Date(value).toLocaleString('de-DE') : ''
    }
  }
}
</script>

<style lang="stylus" scoped>
.wa-order-panel
  margin 24px 0
  padding 16px
  border 1px solid #d8e2dc
  border-left 4px solid #25d366
  background white
  color #263238
  &__header
    display flex
    justify-content space-between
    align-items flex-start
    h3
      margin 0 0 4px
    span, small
      display block
  &__documents
    margin-top 16px
    > div
      display flex
      flex-direction column
      align-items flex-start
      gap 5px
      margin-top 10px
    button
      border 0
      background transparent
      color #167b55
      cursor pointer
  &__messages
    margin-top 18px
    summary
      cursor pointer
      font-weight bold
  &__message
    display flex
    margin-top 8px
    > div
      max-width 75%
      padding 8px 10px
      border-radius 7px
      background #f0f2f5
    p
      margin 0 0 4px
      white-space pre-wrap
    small
      display block
      color #718089
    &--outbound
      justify-content flex-end
      > div
        background #d9fdd3
  &__error
    color #b42318
</style>
